import { render, staticRenderFns } from "./LayerStatisticsTable.vue?vue&type=template&id=f40d5e28"
import script from "./LayerStatisticsTable.vue?vue&type=script&lang=js"
export * from "./LayerStatisticsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports